import { Dispatch, SetStateAction } from 'react';
import { useQuery } from 'react-query';

import { applicationNotesRoute } from '@features/applicationNotes';
import { applicationNotesKey } from '@features/applicationNotes/constants';
import { errorMessage } from '@features/applications';
import axiosInstance from '@server/axiosInstance';

type UseGetApplicationNotesProps = {
  applicationId: number;
  setErrorText: Dispatch<SetStateAction<string>>;
};

export const useGetApplicationNotes = ({
  applicationId,
  setErrorText,
}: UseGetApplicationNotesProps) => {
  const {
    data: applicationNotesData,
    isLoading: isLoadingApplicationNotesData,
  } = useQuery({
    queryKey: [applicationNotesKey, applicationId],
    queryFn: () =>
      axiosInstance
        .get(applicationNotesRoute, {
          params: { application_id: applicationId },
        })
        .then((res) => res.data),
    onSuccess: (data) => {
      if (data.length) {
        setErrorText('');
      }
    },
    onError: () => {
      setErrorText(errorMessage);
    },
  });
  return { applicationNotesData, isLoadingApplicationNotesData };
};
